import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import type { FC } from 'react';

const Footer: FC = () => {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-grid-line text-lg"></i>
              </div>
              <div>
                <span className="font-heading text-lg font-semibold text-background-50 leading-none">Kakobuy</span>
                <span className="block text-xs text-background-400 leading-none mt-0.5">Polska Forum</span>
              </div>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              Największa polska baza wiedzy o Kakobuy Spreadsheet. Znajdź najlepsze produkty, kategorie i poradniki zakupowe.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Nawigacja</h4>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors">Strona Główna</a></li>
              <li><a href="#categories" className="text-sm text-background-400 hover:text-background-100 transition-colors">Kategorie</a></li>
              <li><a href="#stats" className="text-sm text-background-400 hover:text-background-100 transition-colors">Statystyki</a></li>
              <li><a href="#safety" className="text-sm text-background-400 hover:text-background-100 transition-colors">Bezpieczeństwo</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Kategorie</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 7).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.namePl}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">Zasoby</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Przewodnik 2026
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Kakobuy Spreadsheet
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Buy It Now
                </a>
              </li>
              <li>
                <a href="#safety" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Polityka bezpieczeństwa
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/50">
        <div className="section-container py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} Kakobuy Polska Forum. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-xs text-background-600">
            Kakobuy Polska Forum jest niezależną platformą informacyjną. Nie jesteśmy powiązani z Kakobuy.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;